module.exports = __webpack_public_path__ + "img/dep_bakery@2x.4ea3c92c.png";